import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { HelpIndex } from '../../../models/enums';
import * as _ from 'underscore';

@Component({
    standalone: false,
    selector: 'res-other-legal-discovery-options-modal',
    templateUrl: './other-legal-discovery-options-modal.component.html',
    styleUrls: ['./other-legal-discovery-options-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class OtherLegalDiscoveryOptionsComponent extends BaseModalComponent implements OnInit {
    modalTitle = 'Other Legal Discovery Options';
    primaryButtonLabel = 'OK';
    secondaryButtonLabel = 'Cancel';
    isBusy = false;
    isBusyMessage = 'Loading...';
    modalClass = 'other-legal-discovery-options-modal';
    modalAutomationId = 'other-legal-discovery-options';
    modalHelpIndex = HelpIndex.ediscfields_dlg;
    defaultDatePlaceholder = 'YYYY-MM-DD...';
    scanAttributes: any;

    @Input() electronicID: string;
    @Input() dateOfShipment: any;
    @Input() nameOfShipper: string;
    @Input() trackingNumber: string;
    @Input() dateReceived: any;
    @Input() recipientName: string;

    constructor(
        private modalService: BsModalService,
        private changePasswordModalRef: BsModalRef) {
        super(modalService, changePasswordModalRef);
    }

    ngOnInit() {
        if (this.modalData) {
            this.modalData.forEach(element => {
                this[element.name] = element.value;
            });
        }
    }

    ok(): void {
        this.scanAttributes = [
            { name: 'electronicID', value: this.electronicID },
            { name: 'dateOfShipment', value: this.dateOfShipment },
            { name: 'nameOfShipper', value: this.nameOfShipper },
            { name: 'trackingNumber', value: this.trackingNumber },
            { name: 'dateReceived', value: this.dateReceived },
            { name: 'recipientName', value: this.recipientName },
        ];
        this.closeModal(true, this.scanAttributes);
    }
}
